import { Button } from "@ths/ui";
import { useEffect, useRef } from "react";

import { CheckoutReminderPreferences } from "../components/CheckoutReminderPreferences";

export default function GuestSettingsStep({
  token,
  assignmentId,
  onBack,
}: {
  token: string;
  assignmentId: string;
  onBack: () => void;
}) {
  const headingRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    headingRef.current?.focus();
  }, []);
  return (
    <main className="relative z-10 flex flex-1 justify-center p-6">
      <div className="w-full max-w-sm space-y-8 text-on-navy">
        <h1
          ref={headingRef}
          tabIndex={-1}
          className="font-oswald text-3xl font-medium uppercase tracking-wide focus:outline-none"
        >
          Settings
        </h1>
        <section
          aria-labelledby="reminder-settings-title"
          className="space-y-6"
        >
          <div className="space-y-2">
            <h2 id="reminder-settings-title" className="text-lg font-medium">
              Lodging updates
            </h2>
            <p className="text-sm text-on-navy/70">
              Your preferences apply to all your Basecamp stays.
            </p>
          </div>
          <CheckoutReminderPreferences
            token={token}
            assignmentId={assignmentId}
            mode="settings"
          />
        </section>
        <Button
          type="button"
          fullWidth
          variant="ghost"
          onClick={onBack}
          className="min-h-11 text-on-navy/70 hover:bg-on-navy/5 focus-visible:ring-on-navy"
        >
          Back to my stay
        </Button>
      </div>
    </main>
  );
}
